import _get from 'lodash/get';
import React from 'react';
import classes from './ImagesDisplayInputField.module.css';
import { formImages } from 'shared/utility';

const imagesDisplayInputField = (props) => {
  const imagesInputContainerClasses = [classes.Container, classes[props.className]];
  if (props.selected === true) imagesInputContainerClasses.push(classes.Selected);
  if (props.isGift === true) imagesInputContainerClasses.push(classes.GiftPost);

  const imagesInputClasses = [classes.ImagesInput];
  if (props.images.length > 0) imagesInputClasses.push(classes.ImagesAdded);

  let iconImage = props.iconImage ? formImages.find((formImage) => formImage.name === props.iconImage) : null;
  iconImage = iconImage ? <iconImage.image className={classes.ImageIcon} /> : null;

  return (
    <div onClick={props.clicked} className={imagesInputContainerClasses.join(' ')}>
      <div className={imagesInputClasses.join(' ')}>
        {props.images.length < 1 ? (
          <p className={classes.placeholder}>{props.placeholder}</p>
        ) : (
          <div className={classes.ThumbNailsContainer}>
            {props.images.map((image, i) => (
              <div className={classes.ImageHolder} key={i}>
                <img src={_get(image, 'ImageURL', _get(image, 'ThumbURL'))} className={classes.PostImageThumb} alt={`Post Photo${i}`} />
              </div>
            ))}
          </div>
        )}
        <div className={classes.IconContainer}>{iconImage}</div>
      </div>
    </div>
  );
};

export default imagesDisplayInputField;
